import { soddApi } from "./soddApi";

export const authApi = soddApi
    //.enhanceEndpoints({ addTagTypes: [] })
    .injectEndpoints({
        endpoints: (build) => ({
            login: build.mutation({
                query: ({ username, password }) => ({
                    url: "/api/v1/auth/login",
                    method: "POST",
                    body: {
                        username,
                        password,
                    },
                }),
                invalidatesTags: ["user.me"],
            }),
            logout: build.mutation({
                query: () => ({
                    url: "/api/v1/auth/logout",
                    method: "POST",
                }),
                invalidatesTags: ["user.me"],
            }),
        }),
    });

export const { useLoginMutation, useLogoutMutation } = authApi;
